export {
  default as PaletteStyleTag,
  type PaletteStyleTagProps,
} from './PaletteStyleTag';
